import { useState } from "react";
import FaqCard from "./FaqCard";
import Image from "next/image";

const faqContents = [
  {
    id: 1,
    question: "How often do I need to replace the battery on AmarPet Tag?",
    answer:
      "The AmarPet Smart Tag is designed to be battery-free, so you never have to worry about replacing or recharging batteries. It uses a passive NFC chip and QR code that are always ready to use.",
  },
  {
    id: 2,
    question: "Do I need to get a monthly data plan?",
    answer:
      "No, there is no need for a monthly data plan. The AmarPet Smart Tag works via QR code and NFC technology, which does not require any additional data plan or subscription.",
  },
  {
    id: 3,
    question: "How do I activate AmarPet Tag?",
    answer:
      "To activate your AmarPet Tag, download the AmarPet app, create an account, and add your pet’s details. Then, scan the QR code on the tag or manually enter the tag ID to link it to your pet’s profile.",
  },
  {
    id: 4,
    question: "Is the AmarPet Tag waterproof?",
    answer:
      "Yes, the AmarPet Smart Tag is fully waterproof and designed to withstand all weather conditions. Whether your pet loves swimming or playing in the rain, the tag will remain functional.",
  },
  {
    id: 5,
    question: "Can I update my contact information after activating the tag?",
    answer:
      "Yes, you can easily update your contact information through the AmarPet app at any time. Just log in, go to your pet’s profile, and make the necessary changes.",
  },
];

function PetTagFaq() {
  const [selectedQuestionId, setQuestionId] = useState(1);
  return (
    <div className="mx-auto max-w-[69.625rem] flex flex-col gap-[2.25rem] md:gap-0 md:flex-row p-[1rem] overflow-hidden mb-[6.25rem]">
      <div className="md:w-[45%] relative">
        <h2 className="max-w-[16.375rem] text-[2.25rem] lg:text-[2.5rem] font-bold mt-[3rem] md:mt-0">
          Frequently Asked Questions
        </h2>
        <div className="absolute w-[48.625rem] h-[35.875rem] -left-[9rem] -top-[6rem] md:-left-[5.5rem] md:-top-[2rem] -z-10">
          <Image src="/assets/pet-tag/faq-bg.png" fill alt="" />
        </div>
      </div>

      <div className="md:w-[55%] flex flex-col">
        {faqContents.map((faq) => {
          return (
            <FaqCard
              key={faq.id}
              faq={faq}
              selectedQuestionId={selectedQuestionId}
              setQuestionId={setQuestionId}
            />
          );
        })}
      </div>
    </div>
  );
}

export default PetTagFaq;
